export default "__VITE_ASSET__B0WAS8xz__"